module.exports = __webpack_public_path__ + "img/u8435.f4a3a628.png";